import {gatewayUrl} from "config";
import axiosInstance from "utils/axios-request";

interface IInstitutionDetails {
    addressAvailable: string;
    form26AsAvailable: string;
    id: string;
    institutionType: string;
    itrVAvailable: string;
    name: string;
    originalStatementAvailable: string;
    netbankingAllowed: boolean;
}

export const getInstitutions = async (): Promise<IInstitutionDetails[]> => {
    const response = await axiosInstance.request({
        baseURL: gatewayUrl,
        url: "bs-service/institutions",
        method: "post",
        data: {
            handler: "institutions",
        },
    });
    return response.data.institutions;
};
